export const common = {
  assetsURL: "./assets",
  initialCharacterURL: "./assets/img",
  encryptionKeys: {
    payload: "@SiMBA.InSuRAnCE",
    chat: "asdfghjklqwertyuiopzxcvbnmasdfgh@YOLOH.InSuRAnCE"
  }
}
